/* This file is autogenerated, see readme.md for instructions */
import InfoSvgIcon from '@bloomreach/banana-theme/icons/info.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const InfoIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <InfoSvgIcon />
    </Icon>
  );
});

InfoIcon.displayName = 'InfoIcon';

export default InfoIcon;
